export { default } from "./rate"
export type { RateProps } from "./rate"
